import React from 'react';
import ThumbsUpButton from '../ThumbsUpButton/ThumbsUpButton.js';
import ThumbsDownButton from '../ThumbsDownButton/ThumbsDownButton.js';
import RegenerateButton from '../Regenerate/Regenerate.js';
import ClipboardButton from '../ClipboardButton/ClipboardButton.js';
import styles from './ToolBar.module.css';

function ToolBar({ user_id, message_id, chat_id, chatHistory, navigate, message_content, message_sources, setShowFeedback}) {
  return (
    <div className={styles.layout}>
      <ThumbsUpButton
        user_id={user_id}
        message_id={message_id}
      />
      <ThumbsDownButton
        user_id={user_id}
        message_id={message_id}
        setShowFeedback={setShowFeedback}
      />
      <RegenerateButton
        user_id={user_id}
        existingChatId={chat_id}
        chatHistory={chatHistory}
        navigate={navigate}
        existingAssistantMessageId={message_id}
      />
      <ClipboardButton
        user_id={user_id}
        message_id={message_id}
        message_content={message_content}
        message_sources={message_sources}
      />
    </div>
  );
}

export default ToolBar;